/**
 * UserMenu.js
 * Displays current user info and logout button in the header
 */

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import './UserMenu.css';

function UserMenu() {
  const { user, isAuthenticated, logout } = useAuth();
  const [showDropdown, setShowDropdown] = useState(false);
  const navigate = useNavigate();

  if (!isAuthenticated) {
    return (
      <button 
        className="login-link"
        onClick={() => navigate('/login')}
      >
        Sign In
      </button>
    );
  }

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const getInitials = (name) => {
    return name
      .split(' ')
      .map(n => n[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <div className="user-menu">
      <button 
        className="user-menu-trigger"
        onClick={() => setShowDropdown(!showDropdown)}
      >
        <div className="user-avatar">
          {getInitials(user.full_name)}
        </div>
        <div className="user-info">
          <span className="user-name">{user.full_name}</span>
        </div>
        <span className="dropdown-arrow">▼</span>
      </button>

      {showDropdown && (
        <>
          <div 
            className="dropdown-overlay"
            onClick={() => setShowDropdown(false)}
          />
          <div className="user-dropdown">
            <div className="dropdown-header">
              <strong>{user.full_name}</strong>
              <span className="dropdown-email">{user.email}</span>
              {user.company_name && (
                <span className="dropdown-company">{user.company_name}</span>
              )}
            </div>
            <div className="dropdown-divider" />
            <button
              className="dropdown-item"
              onClick={() => {
                setShowDropdown(false);
                navigate('/profile');
              }}
            >
              Profile
            </button>
            <button 
              className="dropdown-item logout"
              onClick={handleLogout}
            >
              Sign Out
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default UserMenu;
